<template>
    <section>
        <!--open list-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters" @submit.native.prevent>
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="Product Name or UPC" clearable @keyup.enter.native="getInventory">
                        <el-button slot="append" icon="el-icon-search" @click="getInventory"></el-button>
                    </el-input>

                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel('/excel/exportInventory','inventory.xls')">Export</el-button>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="addFormVisible=true">Add Product</el-button>
                </el-form-item>

            </el-form>
        </el-col>

        <!--列表-->
        <el-table stripe :data="products" highlight-current-row v-loading="listLoading" :row-class-name="tableRowClassName"
                  style="width: 100%;">
            <el-table-column label="#" prop="productNo" width="80px">
            </el-table-column>
            <el-table-column prop="product" label="Product" width="400px">
                <template slot-scope="scope">
                    {{scope.row.condition}} - <b>{{scope.row.productName}}</b> ({{scope.row.createDate}})
                    <p>{{scope.row.upc}}</p>
                    <p class="note">{{scope.row.note}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="size" label="Categroy">
            </el-table-column>
            <el-table-column prop="inbound" label="INBD">
            </el-table-column>
            <el-table-column prop="stock" label="FBM">
            </el-table-column>
            <el-table-column prop="noClaimed" label="Not Claimed" >
            </el-table-column>
            <el-table-column label="Action" width="300">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleEditProduct(scope.row)">Edit</el-button>
                    <!--<el-button size="small" @click="showEditFBM(scope.row)">Edit FBM</el-button>-->
                    <el-button size="small" @click="showDetail(scope.row.productNo)">Detail</el-button>
                    <el-button size="small" type="danger" @click="deleteProduct(scope.row.productNo)">Delete</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleInventoryChange" :page-size="pageSize"
                           :total="inventoryTotal" style="float:right;">
            </el-pagination>
        </el-col>

        <!--新增界面-->
        <el-dialog title="Add Product" width="80%" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addProduct" label-width="220px" :rules="formRules" ref="addProduct">
                <el-form-item label="Name" prop="product">
                    <el-input v-model="addProduct.product" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Price" prop="price">
                    <el-input-number :min="0" v-model="addProduct.price"></el-input-number>
                </el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="addProduct.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ASIN" prop="asin">
                    <el-input v-model="addProduct.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC" prop="upc">
                    <el-input v-model="addProduct.upc"></el-input>
                </el-form-item>
                <el-form-item label="Weight" prop="weight">
                    <el-input v-model="addProduct.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <el-input v-model="addProduct.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddProduct" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Edit Product" width="80%" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editProduct" label-width="220px" :rules="formRules" ref="editProduct">
                <el-form-item label="Name" prop="Name">
                    <el-input v-model="editProduct.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Price" prop="price">
                    <el-input-number :min="0" v-model="editProduct.price"></el-input-number>
                </el-form-item>
                <el-form-item label="Category" prop="size">
                    <el-select v-model="editProduct.size" auto-complete="off" :disabled="true">
                        <el-option v-for="(size,index) in sizeList" :key="index" :value="size" :label="size"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Condition" prop="condition">
                    <el-select v-model="editProduct.condition" auto-complete="off">
                        <el-option v-for="(condition,index) in conditions" :key="index" :value="condition" :label="condition"></el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="Price">
                    <el-input-number v-model="editProduct.price" :min="0"></el-input-number>
                </el-form-item>-->
                <el-form-item label="ASIN">
                    <el-input v-model="editProduct.asin"></el-input>
                </el-form-item>
                <el-form-item label="UPC">
                    <el-input v-model="editProduct.upc"></el-input>
                </el-form-item>
                <el-form-item label="Weight">
                    <el-input v-model="editProduct.weight"></el-input>
                </el-form-item>
                <el-form-item label="Note">
                    <el-input v-model="editProduct.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Edit Product FBM" width="80%" :visible.sync="editFBMVisible" :close-on-click-modal="false">
            <el-form :model="fbm" label-width="220px" :rules="fbmFormRules" ref="fbm">
                <el-form-item label="Name" prop="productName">
                    <el-input v-model="fbm.productName" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Warehouse" prop="warehouseNo">
                    <el-select v-model="fbm.warehouseNo">
                        <el-option v-for="(warehouse,index) in warehouseList" :key="index" :value="warehouse.warehouseNo" :label="warehouse.state+' ' +warehouse.city+' '+warehouse.address"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Price" prop="price">
                    <el-input-number v-model="fbm.price" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Quantity" prop="quantity">
                    <el-input-number v-model="fbm.quantity" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <el-input v-model="fbm.note" type="textarea" rows="5" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFBMVisible = false">Close</el-button>
                <el-button type="primary" @click.native="addFBM" :loading="loading">Submit</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Product Detail" width="80%" :visible.sync="detailVisible" :close-on-click-modal="false">
            <el-tabs v-model="activeName" type="card" @tab-click="">
                <el-tab-pane label="Inbound History" name="first">
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-input v-model="filters.tracking" placeholder="Tracking Number" clearable @keyup.enter.native="getInboundList">
                                    <el-button slot="append" icon="el-icon-search" @click="getInboundList"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="filters.inboundUser" placeholder="User" @change="getInboundList()" filterable clearable>
                                    <el-option v-for="(member,index) in members" :label="member.username" :value="member.userNo" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="filters.inboundType" placeholder="Inbound Source" @change="getInboundList()" filterable clearable>
                                    <el-option value="Offer" label="Offer"></el-option>
                                    <el-option value="Channel" label="Channel"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-table stripe :data="inboundList" highlight-current-row v-loading="firstListLoading"
                              style="width: 100%;">
                        <el-table-column prop="productName" label="Product Name" >
                        </el-table-column>
                        <el-table-column prop="userName" label="User" >
                        </el-table-column>
                        <el-table-column label="Warehouse" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                                <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="inboundType" label="Inbound Source" >
                        </el-table-column>
                        <el-table-column prop="price" label="Price" >
                        </el-table-column>
                        <el-table-column prop="quantity" label="Qty" >
                        </el-table-column>
                        <el-table-column prop="tracking" label="Tracking" >
                        </el-table-column>
                        <el-table-column prop="inboundDate" label="Inbound Date" >
                        </el-table-column>
                    </el-table>
                    <!--工具条-->
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="handleChangeInboundList" :page-size="pageSize"
                                       :total="inboundTotal" style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="FBM" name="second">
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-input v-model="filters.inventoryProduct" placeholder="ProductName" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" v-on:click="getInventoryDetail(null)">Search</el-button>
                            </el-form-item>
                            <el-form-item style="float:right;">
                                <el-select clearable placeholder="Filter by user" v-model="filters.inventoryNurse" :filterable="true" @change="getInventoryDetail(null)">
                                    <el-option v-for="(nurse,index) in members" :label="nurse.username"
                                               :value="nurse.userNo" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-table stripe :data="fbmDetail" highlight-current-row v-loading="fbmDetailLoading"
                              style="width: 100%;">
                        <el-table-column type="index">
                        </el-table-column>
                        <el-table-column prop="productNme" label="Product">
                        </el-table-column>
                        <el-table-column prop="warehouseUserName" label="UserName">
                        </el-table-column>
                        <el-table-column prop="warehouse" label="Warehouse">
                            <template slot-scope="scope">
                                <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                                <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="qty" label="Qty">
                        </el-table-column>
                    </el-table>
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="handleInventoryDetailPageChange"
                                       :page-size="pageSize" :total="fbmTotal" style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>
                <!--<el-tab-pane label="FBA" name="third">

                </el-tab-pane>-->
                <el-tab-pane label="Outbound History" name="third">
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-select v-model="filters.outboundUser" placeholder="User" filterable clearable @change="getOutboundList">
                                    <el-option v-for="(member,index) in members" :label="member.username"
                                               :value="member.userNo" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-table stripe :data="outboundList" highlight-current-row v-loading="thirdListLoading">
                        <el-table-column prop="outboundId" label="#" width="100px">
                        </el-table-column>
                        <el-table-column label="Product Name">
                            <template slot-scope="scope">
                                <div v-html="scope.row.productName"></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="users" label="Users" >
                        </el-table-column>
                        <el-table-column prop="status" label="Status">
                            <template slot-scope="scope">
                                <el-tag type="info" v-if="scope.row.status===1">Pending</el-tag>
                                <el-tag type="success" v-if="scope.row.status===2">Success</el-tag>
                                <el-tag type="danger" v-if="scope.row.status===3">Closed</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="outboundDate" label="Outbound Date">
                        </el-table-column>
                    </el-table>
                    <!--工具条-->
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="handleChangeOutboundList" :page-size="pageSize"
                                       :total="outboundTotal" style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="Reported/Missed" name="fourth">
                    <!--<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-input v-model="filters.reportFilter" placeholder="Offer" clearable>
                                    <el-button slot="append" icon="el-icon-search" @click="getReportList"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>-->

                    <!--列表-->
                    <el-table stripe :data="reportedInbound" highlight-current-row v-loading="fourthListLoading" style="width: 100%;">
                        <el-table-column prop="id" label="#">
                        </el-table-column>
                        <el-table-column prop="product" label="Offer">
                            <template slot-scope="scope">
                                <p>{{scope.row.productName}} {{scope.row.offerCreateDate?"("+scope.row.offerCreateDate+")":""}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user" label="User">
                        </el-table-column>
                        <el-table-column label="Warehouse" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                                <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="Price">
                        </el-table-column>
                        <el-table-column prop="quantity" label="Qty">
                        </el-table-column>
                        <el-table-column label="Status">
                            <template slot-scope="scope">
                                <p v-if="scope.row.status===0"><el-tag type="info">Pending</el-tag></p>
                                <p v-if="scope.row.status===1"><el-tag type="success">Confirmed</el-tag></p>
                                <p v-if="scope.row.status===2"><el-tag type="danger">Rejected</el-tag></p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createDate" label="Report Date">
                        </el-table-column>
                        <el-table-column prop="note" label="Note">
                        </el-table-column>
                    </el-table>

                    <!--工具条-->
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="changeReportPage" :page-size="pageSize" :total="reportTotal"
                                       style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="Not Claimed" name="five">
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-input v-model="filters.notClaimedTracking" placeholder="Tracking" clearable>
                                    <el-button slot="append" icon="el-icon-search" @click="getNotClaimed"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <!--列表-->
                    <el-table stripe :data="notClaimed" highlight-current-row v-loading="fiveListLoading" style="width: 100%;">
                        <el-table-column prop="id" label="#">
                        </el-table-column>
                        <el-table-column prop="productName" label="ProductName">
                        </el-table-column>
                        <el-table-column prop="trackingNumber" label="Tracking Number">
                        </el-table-column>
                        <el-table-column prop="userName" label="User">
                        </el-table-column>
                        <el-table-column label="Warehouse" >
                            <template slot-scope="scope">
                                <p v-if="scope.row.isDoctor==0"><i class="fa fa-university"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                                <p v-if="scope.row.isDoctor==1"><i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp;{{scope.row.warehouse}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="qty" label="Qty">
                        </el-table-column>
                        <el-table-column prop="dateTime" label="DateTime">
                        </el-table-column>
                    </el-table>

                    <!--工具条-->
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="changeNotClaimedPage" :page-size="pageSize" :total="notClaimedTotal"
                                       style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>

                <el-tab-pane label="FBM Operation Log" name="six">
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                        <el-form :inline="true" :model="filters">
                            <el-form-item>
                                <el-select v-model="filters.stockFilter" placeholder="Type" filterable clearable @change="getStockList">
                                    <el-option label="All" value="" ></el-option>
                                    <el-option label="Nurse Claimed" :value="1" ></el-option>
                                    <el-option label="Doctor Confirm Report" :value="2" ></el-option>
                                    <el-option label="Doctor Outbound" :value="3" ></el-option>
                                    <el-option label="Doctor Cancel Outbound" :value="7" ></el-option>
                                    <el-option label="Warehouse Inbound" :value="4" ></el-option>
                                    <el-option label="Warehouse Reverse" :value="5" ></el-option>
                                    <el-option label="Warehouse Batch Reverse" :value="8" ></el-option>
                                    <el-option label="Warehouse Edit FBM" :value="6" ></el-option>
                                    <el-option label="Doctor Transfer" :value="9" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>

                    <!--列表-->
                    <el-table stripe :data="stockList" highlight-current-row v-loading="sixListLoading" style="width: 100%;">
                        <el-table-column prop="id" label="#">
                        </el-table-column>
                        <el-table-column prop="srcStock" label="Before operating FBM">
                        </el-table-column>
                        <el-table-column prop="qty" label="Qty">
                        </el-table-column>
                        <el-table-column prop="destStock" label="After operating FBM">
                        </el-table-column>
                        <el-table-column label="Type">
                            <template slot-scope="scope">
                                <p v-if="scope.row.bizType==1">Nurse Claimed</p>
                                <p v-if="scope.row.bizType==2">Doctor Confirm Report</p>
                                <p v-if="scope.row.bizType==3">Doctor Outbound</p>
                                <p v-if="scope.row.bizType==4">Warehouse Inbound</p>
                                <p v-if="scope.row.bizType==5">Warehouse Reverse</p>
                                <p v-if="scope.row.bizType==6">Warehouse Edit FBM</p>
                                <p v-if="scope.row.bizType==7">Doctor Cancel Outbound</p>
                                <p v-if="scope.row.bizType==8">Warehouse Batch Reverse</p>
                                <p v-if="scope.row.bizType==9">Doctor Transfer</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="Operator" prop="userName"></el-table-column>
                        <el-table-column prop="createdTime" label="DateTime">
                        </el-table-column>
                    </el-table>

                    <!--工具条-->
                    <el-col :span="24" class="toolbar">
                        <el-pagination layout="prev, pager, next" @current-change="changeStockPage" :page-size="pageSize" :total="stockTotal"
                                       style="float:right;">
                        </el-pagination>
                    </el-col>
                </el-tab-pane>
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="detailVisible = false">Close</el-button>
            </div>
        </el-dialog>

        <el-dialog title="FBM Detail" width="80%" :visible.sync="fbmDetailVisible" :close-on-click-modal="false">

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="fbmDetailVisible = false">Close</el-button>
            </div>
        </el-dialog>
    </section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
    import {conditions} from "../../globalVar"
    import {
        getInventory,
        addProduct,
        getInventoryReportList,
        editFBM,
        getFBM,
        getProductFBM,
        deleteProduct,
        getStockHistory,
        getSizeList
    } from '../../api/inventoryService';
    import ElOption from "element-ui/packages/select/src/option";
    import {getProductInboundList} from "../../api/inboundService";
    import {getCurrentWarehouse} from "../../api/warehouseService";
    import {getDoctorNurse} from "../../api/memberService";
    import {getOutboundByProduct,getInventorySummary,getInventoryList} from "../../api/outboundService";
    import {getDoctorMemberList} from "../../api/memberService";
    import {getNotClaimed} from "../../api/inventoryService";
    import {exportExcel} from "../../api/exportService";

    export default {
        components: {ElOption},
        data() {
            return {
                pageSize:defaultPageSize,

                conditions:conditions,
                activeName: "first",
                filters: {
                    fbmWarehouse:"",
                    fbmStatus:"",
                    reportFilter:"",
                    inboundFilter:"",
                    inboundUser:"",
                    outboundUser:"",
                    tracking:"",
                    name: '',
                    product:"",
                    inboundType:"",
                    inventoryProductSummary:"",
                    notClaimedTracking:"",
                    stockFilter:""
                },
                fbmDetailVisible:false,

                currentDetailNo:"",
                currentInventroy:"",

                products: [],
                inventoryPage:1,
                inventoryTotal:0,

                inboundPage:1,
                inboundTotal:0,

                reportPage:1,
                reportTotal:0,

                outboundPage:1,
                outboundTotal:0,


                notClaimedPage:1,
                notClaimedTotal:0,

                inventorySummaryPage:1,
                inventorySummaryTotal:0,

                stockPage:1,
                stockTotal:0,

                fbmDetail:[],
                fbmPage:1,
                fbmTotal:0,

                total: 0,
                page: 1,
                listLoading: false,
                sels: [],//列表选中列

                nurseList:[],
                inboundList:[],
                outboundList:[],
                fbmList:[],
                fmaList:[],
                reportedInbound:[],
                notClaimed:[],
                inventoriesSummary:[],
                stockList:[],

                members:[],

                sizeList:[],

                firstListLoading: false,
                secondListLoading:false,
                thirdListLoading:false,
                fourthListLoading:false,
                fiveListLoading:false,
                sixListLoading:false,

                editFBMVisible:false,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                inventorySummaryLoading:false,

                addFormVisible: false,//新增界面是否显示
                loading: false,
                formRules: {
                    product: [
                        {required: true, message: 'Product Name is required.', trigger: 'blur'}
                    ],
                    price: [
                        {required: true, message: 'Price is required.', trigger: 'blur'}
                    ]
                },
                fbmFormRules: {
                    warehouseNo: [
                        {required: true, message: 'Warehouse is required.', trigger: 'blur'}
                    ],
                    quantity: [
                        {required: true, message: 'Quantity is required.', trigger: 'blur'},
                        {validator:this.checkQuantity, trigger: 'blur'}
                    ]
                },

                inputVisible:false,
                inputValue:"",

                detailVisible:false,
                fbmDetailLoading:false,

                editProduct:{
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:""
                },
                //新增界面数据
                addProduct: {
                    id: "",
                    product: '',
                    condition: "New",
                    price: "",
                    asin: "",
                    upc: "",
                    weight: '',
                    note: "",
                    size:""
                },
                fbm:{
                    warehouseNo:"",
                    price:0,
                    quantity:0,
                    productNo:"",
                    productName:"",
                    note:""
                },
                warehouseList:[]
            }
        },
        methods: {
            deleteProduct(productNo){
                getProductFBM({productNo:productNo}).then((data)=>{
                    if(data.status=="200"){
                        if(data.result>0){
                            this.$message.error("You can't delete a product if FBM left more then 0.");
                        }else{
                            this.$confirm("Are you sure?","Warning",{
                                type:"warning"
                            }).then(()=>{
                                deleteProduct({productNo:productNo}).then((data)=>{
                                    if(data.status=="200"){
                                        this.$message.success("Success");
                                        this.getInventory();
                                    }else{
                                        this.$message.error(data.message);
                                    }
                                })
                            }).catch(()=>{

                            })

                        }
                    }
                })
            },
            exportExcel(url,fileName){
                let param = {
                    url:url,
                    fileName:fileName
                }
                exportExcel(param).then(function(){

                })
            },
            tableRowClassName({row, rowIndex}) {
                if (row.stock ===0) {
                    return 'warning';
                } else {
                    return '';
                }
            },
            handleInventorySummaryPageChange(val) {
                this.inventorySummaryPage = val;
                this.getInventorySummary();
            },
            getInventorySummary(){
                let param = {
                    current:this.inventorySummaryPage,
                    size:this.pageSize,
                    productName:this.filters.inventoryProductSummary,
                };
                this.inventorySummaryLoading= true;
                return getInventorySummary(param).then((data)=>{
                    this.inventorySummaryLoading= false;
                    if(data.status===200){
                        this.inventoriesSummary = data.result.records;
                        this.inventorySummaryTotal = data.result.total;
                    }
                })
            },
            handleInventoryDetailPageChange(val) {
                this.fbmPage = val;
                this.getInventoryDetail();
            },
            getInventoryDetail(){
                let param = {
                    current:this.fbmPage,
                    size:this.pageSize,
                    productName:this.filters.inventoryProduct,
                    nurseId:this.filters.inventoryNurse,
                    productNo:this.currentDetailNo
                };
                this.fbmDetailLoading= true;
                return getInventoryList(param).then((data)=>{
                    this.fbmDetailLoading= false;
                    if(data.status===200){
                        this.fbmDetail = data.result.records;
                        this.fbmTotal = data.result.total;
                    }
                })
            },
            getNotClaimed(){
                let param = {
                    current:this.notClaimedPage,
                    size:this.pageSize,
                    productNo:this.currentDetailNo,
                    tracking:this.filters.notClaimedTracking
                }
                this.fiveListLoading = true;
                getNotClaimed(param).then((res)=>{
                    this.fiveListLoading = false;
                    if(res.status===200){
                        this.notClaimed = res.result.records;
                        this.notClaimedTotal = res.result.total;
                    }
                })
            },
            getDoctorMembers(){
                getDoctorMemberList({}).then((data) => {
                    if (data.status === 200) {
                        this.members = data.result;
                    }
                })
            },
            getSizeList(){
                getSizeList({}).then((data)=>{
                    if (data.status === 200) {
                        this.sizeList = data.result;
                    }
                })
            },
            getFBMList(){
                let param = {
                    current:this.fbmPage,
                    size:this.pageSize,
                    warehouseNo:this.filters.fbmWarehouse,
                    type:this.filters.fbmStatus,
                    productNo:this.currentDetailNo
                }
                this.thirdListLoading = true;
                getFBM(param).then((data) => {
                    this.thirdListLoading = false;
                    if(data.status===200){
                        this.fbmList = data.result.records;
                        this.fbmTotal = data.result.total;
                    }
                })
            },
            addFBM(){
                this.$refs.fbm.validate((valid)=>{
                    if(valid){
                        let param = {
                            productNo:this.fbm.productNo,
                            price:this.fbm.price,
                            warehouseNo:this.fbm.warehouseNo,
                            note:this.fbm.note,
                            qty:this.fbm.quantity
                        }
                        this.loading = true;
                        editFBM(param).then((data)=>{
                            this.loading = false;
                            if(data.status===200){
                                this.$message.success(data.message);
                                this.editFBMVisible = false;
                                this.$refs.fbm.resetFields();
                                this.getInventory();
                            }else{
                                this.$message.error(data.message);
                            }
                        })
                    }
                })
            },
            checkQuantity(rule, value, callback) {
                if (!value>0) {
                    return callback(new Error('Quantity must more than 1.'));
                }else{
                    callback();
                }
            },
            getCurrentWarehouse(){
                getCurrentWarehouse({}).then((data)=>{
                    if(data.status===200){
                        this.warehouseList = data.result;
                    }
                })
            },
            showEditFBM(row){
                this.fbm.productName = row.productName;
                this.fbm.productNo = row.productNo;
                this.editFBMVisible = true;
            },
            changeNotClaimedPage(val){
                this.notClaimedPage = val;
                this.getNotClaimed();
            },
            changeReportPage(val){
                this.reportPage = val;
                this.getReportList();
            },
            changeFBMPage(val){
                this.fbmPage = val;
                this.getFBMList();
            },
            changeStockPage(val){
                this.stockPage = val;
                this.getStockList();
            },
            getReportList() {
                let param = {
                    current:this.reportPage,
                    size:this.pageSize,
                    condition:this.filters.reportFilter,
                    status:this.filters.reportStatus,
                    productId:this.currentDetailNo
                }
                this.fourthListLoading = true;
                getInventoryReportList(param).then((data) => {
                    this.fourthListLoading = false;
                    if(data.status===200){
                        this.reportedInbound = data.result.records;
                        this.reportTotal = data.result.total;
                    }
                })
            },
            getInboundList(){
                let param = {
                    current:this.inboundPage,
                    size:this.pageSize,
                    productNo:this.currentDetailNo,
                    condition:this.filters.inboundFilter,
                    userNo:this.filters.inboundUser,
                    type:this.filters.inboundType,
                    tracking:this.filters.tracking
                };
                this.firstListLoading = true;
                getProductInboundList(param).then((data)=>{
                    this.firstListLoading = false;
                    if(data.status===200){
                        this.inboundList = data.result.records;
                        this.inboundTotal = data.result.total;
                    }
                })
            },
            getOutboundList(){
                let param = {
                    current:this.outboundPage,
                    size:this.pageSize,
                    productNo:this.currentDetailNo,
                    userNo:this.filters.outboundUser
                };
                this.thirdListLoading = true;
                getOutboundByProduct(param).then((data)=>{
                    this.thirdListLoading = false;
                    if(data.status===200){
                        this.outboundList = data.result.records;
                        this.outboundTotal = data.result.total;
                    }
                })
            },
            getStockList(){
                let param = {
                    current:this.stockPage,
                    size:this.pageSize,
                    productNo:this.currentDetailNo,
                    bizType:this.filters.stockFilter
                };
                this.sixListLoading = true;
                getStockHistory(param).then((data)=>{
                    this.sixListLoading = false;
                    if(data.status===200){
                        this.stockList = data.result.records;
                        this.stockTotal = data.result.total;
                    }
                })
            },
            showDetail(id){
                this.currentDetailNo = id;
                this.detailVisible = true;
                this.filters.tracking = "";
                this.getInboundList();
                this.getReportList();
                this.getOutboundList();
                this.getNotClaimed();
                this.getInventoryDetail();
                this.getStockList();
            },
            handleInventoryChange(val){
                this.inventoryPage = val;
                this.getInventory();
            },
            handleEditProduct(row){
                this.editProduct = row;
                this.editFormVisible = true;
            },
            handleCurrentChange(val) {
                this.page = val;
            },

            handleChangeInboundList(val){
                this.inboundPage = val;
                this.getInboundList();
            },
            handleChangeOutboundList(val){
                this.outboundPage = val;
                this.getOutboundList();
            },
            //获取用户列表
            getInventory() {
                let para = {
                    current: this.inventoryPage,
                    size:this.pageSize,
                    condition: this.filters.name
                };
                this.listLoading = true;
                getInventory(para).then((res) => {
                    this.listLoading = false;
                    if(res.status===200){
                        this.products = res.result.records;
                        this.inventoryTotal = res.result.total;
                    }
                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //编辑
            editSubmit: function () {
                this.$refs.editProduct.validate((valid) => {
                    if (valid) {
                        let param = {
                            productNo:this.editProduct.productNo,
                            // productName:this.editProduct.productName,
                            condition:this.editProduct.condition,
                            asin:this.editProduct.asin,
                            upc:this.editProduct.upc,
                            weight:this.editProduct.weight,
                            note:this.editProduct.note,
                            price:this.editProduct.price
                        };
                        this.loading = true;
                        addProduct(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.editFormVisible = false;
                                this.$refs.editProduct.resetFields();
                                this.getInventory();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            },
            //新增
            handleAddProduct: function () {
                this.$refs.addProduct.validate((valid) => {
                    if (valid) {
                        let param = {
                            productName:this.addProduct.product,
                            condition:this.addProduct.condition,
                            asin:this.addProduct.asin,
                            upc:this.addProduct.upc,
                            weight:this.addProduct.weight,
                            note:this.addProduct.note,
                            price:this.addProduct.price
                        };
                        this.loading = true;
                        addProduct(param).then((res)=>{
                            this.loading = false;
                            if(res.status===200){
                                this.$message({
                                    message:res.message,
                                    type:"success"
                                });
                                this.addFormVisible = false;
                                this.$refs.addProduct.resetFields();
                                this.getInventory();
                            }else {
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                });
            }
        },
        mounted() {
            this.getInventory();
            this.getCurrentWarehouse();
            this.getDoctorMembers();
            // this.getSizeList();
        }
    }

</script>

<style>
    .warning{
        color: #c3c3c3;
    }
</style>


// WEBPACK FOOTER //
// inventory.vue?213c240a